module.exports = __webpack_public_path__ + "img/MCMUG25.f0fe8545.png";